import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import axios from "@/services/axios.config";
import { toastOnError } from "@/utils/toastOnError";

type ReqDataType = {
	comment: string;
	methodologyRoundId: number;
};

const submitFeedback = async (data: ReqDataType) =>
	axios.post("/reviews/add-comment", data).catch((err) => Promise.reject(err.response.data as APIResponse));

export default function usePostFeedback() {
	const queryClient = useQueryClient();

	return useMutation(submitFeedback, {
		onSuccess: () => {
			toast.success("Comment added successfully!");
			queryClient.invalidateQueries({
				queryKey: ["reviewComments"],
			});
			queryClient.invalidateQueries({
				queryKey: ["methodologyDetailsWithRound"],
			});
		},
		onError: (err: APIResponse) => {
			toastOnError(err, "Failed to comment!");
		},
	});
}
